// utils/useRoute.js
import { inject } from 'vue';

export function useRoute() {
  return inject('route');
}